import React from 'react';
import LoadingPlaceholder from '../../../../muiComponents/LoadingPlaceholder';

const BookingDetailLoading = () => {
    return (
        <>
            <div className='booking__title'>
                <LoadingPlaceholder variant='text' />
            </div>
            <main className='booking__main'>
                <section className='booking__section'>
                    <LoadingPlaceholder variant='text' width={'100%'} />
                    <LoadingPlaceholder
                        variant='rounded'
                        width={'100%'}
                        height={200}
                    />
                </section>
                <section className='booking__section'>
                    <LoadingPlaceholder variant='text' width={'100%'} />
                    <LoadingPlaceholder
                        variant='rounded'
                        width={'100%'}
                        height={200}
                    />
                </section>
                <section className='booking__section'>
                    <LoadingPlaceholder variant='text' width={'100%'} />
                    <LoadingPlaceholder
                        variant='rounded'
                        width={'100%'}
                        height={200}
                    />
                </section>
            </main>
        </>
    );
};

export default BookingDetailLoading;
